<template>
    <v-app v-if="loader">
        <div class="lds-circle">
            <h1>Loading ...</h1>
            <div></div>
        </div>
    </v-app>
    <v-app v-else>
        <v-dialog v-model="dialog" width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    Update Your Task
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" lazy-validation @submit.prevent="updateTodo">
                        <v-text-field
                                v-model.lazy="selectedTodo.name"
                                :value="selectedTodo.name"
                                required
                        >
                        </v-text-field>
                        <v-btn @click="updateTodo">Update</v-btn>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-container d-flex align-content-center justify-center>
            <v-flex xs12 sm8>
                <v-content flat class="text-right">
                    <v-btn @click="logOut" small>
                        Log Out
                    </v-btn>
                </v-content>
                <v-text-field
                        v-model="newTodo.name"
                        label="What are you working on?"
                        type="text"
                        class="text--reset-border-bottom"
                        @keyup.enter="addNewTodo"

                >
                    <v-fade-transition slot="append">
                        <v-icon
                                color="primary"
                                v-if="newTodo.name"
                                @click="addNewTodo"
                        >
                            add_circle
                        </v-icon>
                    </v-fade-transition>
                </v-text-field>

                <h2 class="display-1 success--text pl-3">
                    Tasks:&nbsp;
                    <v-fade-transition leave-absolute>
                        <span :key="`tasks-${todoListLength}`">
                          {{ todoListLength }}
                        </span>
                    </v-fade-transition>
                </h2>

                <v-divider class="mt-3"></v-divider>

                <v-layout
                        my-1
                        align-center
                >
                    <strong class="mx-3 info--text text--darken-3">
                        Remaining: {{ remainingTasks }}
                    </strong>

                    <v-divider vertical></v-divider>

                    <strong class="mx-3 black--text">
                        Completed: {{ completedTasks }}
                    </strong>

                    <v-spacer></v-spacer>

                    <v-progress-circular
                            :value="progress"
                            class="mr-2"
                    ></v-progress-circular>
                </v-layout>

                <v-divider class="mb-3"></v-divider>

                <v-card v-if="todoListLength > 0">

                    <transition-group name="slide">

                        <v-list-tile class="py-2 list-item--border-bottom" :key="`${task.name} - ${task.id}`"
                                     v-for="(task, i) in todoList">
                            <v-list-tile-action class="pointer-on-hover" @click="changeCompletedState(task)">
                                <v-icon v-if="task.completed" color="success">
                                    done
                                </v-icon>
                                <v-icon v-else>
                                    done
                                </v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <div
                                        slot="label"
                                        :class="task.completed && 'grey--text  text--line-through' || 'text--primary || '"
                                        class="ml-3"
                                        v-text="task.name"
                                ></div>
                            </v-list-tile-content>

                            <v-spacer></v-spacer>

                            <v-speed-dial :direction="direction" :open-on-hover="hover" :transition="transition">
                                <v-btn small fab slot="activator" color="blue darken-2" dark>
                                    <v-icon>settings</v-icon>
                                    <v-icon>close</v-icon>
                                </v-btn>
                                <v-btn @click="showDialogBox(task)" fab dark small color="green">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn @click="changeCompletedState(task)" fab dark small color="indigo">
                                    <v-icon v-if="task.completed">
                                        undo
                                    </v-icon>
                                    <v-icon v-else>
                                        check
                                    </v-icon>
                                </v-btn>
                                <v-btn @click="removeTodo(task)" fab dark small color="red">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-speed-dial>
                        </v-list-tile>

                    </transition-group>

                </v-card>
            </v-flex>
        </v-container>
    </v-app>
</template>

<script>

    export default {
        data() {
            return {
                dialog: false,
                newTodo: {
                    name: '',
                    completed: false
                },
                loader: true,
                selectedTodo: {
                    name: '',
                    completed: false
                },
                direction: 'left',
                hover: true,
                transition: 'slide-x-reverse-transition'
            }
        },
        computed: {
            todoList() {
                this.$store.dispatch('sortTodos');
                return this.$store.getters.todos;
            },
            todoListLength() {
                return this.$store.getters.todos.length;
            },
            progress() {
                return this.completedTasks / this.todoListLength * 100
            },
            completedTasks() {
                return this.todoList.filter(task => task.completed).length
            },
            remainingTasks() {
                return this.todoListLength - this.completedTasks
            }
        },
        created() {
            if (!sessionStorage.getItem('token')) {
                this.$router.push('/login')
            }
        },
        async mounted() {
            await this.$store.dispatch('getTodos');
            this.loader = false
        },
        methods: {
            create() {
                this.addNewTodo();
            },
            resetTodo(todo) {
                todo = {
                    name: '',
                    completed: false
                }
            },
            addNewTodo() {
                this.$store.dispatch('addTodo', this.newTodo);
                this.newTodo = {
                    name: '',
                    completed: false
                }
            },
            updateTodo() {
                this.$store.dispatch('updateTodo', this.selectedTodo);
                this.selectedTodo = {
                    name: '',
                    completed: false
                }
                this.dialog = false;
            },
            removeTodo(todo) {
                this.$store.dispatch('removeTodo', todo);
            },
            showDialogBox(todo) {
                this.selectedTodo = todo;
                this.dialog = true;
            },
            changeCompletedState(todo) {
                this.$store.dispatch('changeCompletedState', todo);
            },
            saveTodosToSessionSotrage() {
                sessionStorage.setItem('todos', JSON.stringify(this.$store.getters.todo));
            },
            logOut() {
                this.$store.dispatch('removeToken');
                this.$router.push('/login');
            }
        }

    }
</script>

<style>


</style>

